import { APP_HEADER_LINKS } from '@/constants/config';
import { FEATURE_FLAGS } from '@/constants/feature-flags';
import { PopoverLink } from '../PopoverLink';
import React from 'react';

/**
 * Profile menu content rendered inside PageHeader popover.
 */
export const PopoverContentProfile: React.FC = () => {
  const profileLinks = APP_HEADER_LINKS.filter((l) => l.parent === 'profile');

  return (
    <div>
      <ul className="space-y-4 text-base text-neutral-black">
        {profileLinks.map((link) => (
          <li key={link.labelKey}>
            <PopoverLink
              disabled={link.featureFlag ? !FEATURE_FLAGS[link.featureFlag] : false}
              external={link.external}
              href={link.href}
              icon={link.icon}
              label={link.label}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

PopoverContentProfile.displayName = 'PopoverContentProfile';

export default PopoverContentProfile;
